var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartMoneyMoves(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.589355,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#F1ECFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6453_12351)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6453_12351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 12.5894H14.875V13.4644V14.3394V16.0894H16.625V14.384C18.8633 14.5704 20.902 15.4567 22.5234 16.8296L21.3185 18.0336L22.5557 19.2709L23.7598 18.0669C25.1326 19.6874 26.019 21.727 26.2054 23.9652H24.5V25.7152H26.25H27.125H28V24.8402C28 18.0844 22.505 12.5894 15.75 12.5894Z",
    fill: "#795AF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3622 20.4643L20.125 19.2271L17.7502 21.6018C17.4081 21.4382 17.0292 21.3393 16.625 21.3393C15.1751 21.3393 14 22.5144 14 23.9643C14 25.4142 15.1751 26.5893 16.625 26.5893C18.0749 26.5893 19.25 25.4142 19.25 23.9643C19.25 23.5601 19.1511 23.1812 18.9875 22.8391L21.3622 20.4643Z",
    fill: "#795AF7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6453_12351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12.5894)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6453_12351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(14 12.5894)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartMoneyMoves);
export default __webpack_public_path__ + "static/media/smart-money-moves.1e7cb73d0cb30b9fb027570f192b450f.svg";
export { ForwardRef as ReactComponent };